import { createFileRoute } from '@tanstack/react-router';

import { requireAdmin } from '@/components/admin/require-admin.ts';
import { TeacherListPage } from '@/views/admin/teacher-list-page.tsx';

export const Route = createFileRoute('/admin/teachers')({
  beforeLoad: requireAdmin,
  component: TeacherListPage,
});
